import React from 'react'
import { NumberPicker as FormilyNumberPicker } from '@formily/antd-v5'
import { createBehavior, createResource } from '@designable/core'
import { createFieldSchema } from '../Field'
import { AllSchemas } from '../../schemas'
import { AllLocales } from '../../locales'
import { DnFC } from '../../../react'

export const NumberPicker: DnFC<
  React.ComponentProps<typeof FormilyNumberPicker>
> = (props) => {
  const safeProps = { ...props }
  if (safeProps.formatter !== undefined && typeof safeProps.formatter !== 'function') {
    delete safeProps.formatter
  }
  if (safeProps.parser !== undefined && typeof safeProps.parser !== 'function') {
    delete safeProps.parser
  }
  return React.createElement(FormilyNumberPicker, safeProps)
}

NumberPicker.Behavior = createBehavior({
  name: 'NumberPicker',
  extends: ['Field'],
  selector: (node) => node.props?.['x-component'] === 'NumberPicker',
  designerProps: {
    propsSchema: createFieldSchema(AllSchemas.NumberPicker),
  },
  designerLocales: AllLocales.NumberPicker,
})

NumberPicker.Resource = createResource({
  icon: 'NumberPickerSource',
  elements: [
    {
      componentName: 'Field',
      props: {
        type: 'number',
        title: 'NumberPicker',
        'x-decorator': 'FormItem',
        'x-component': 'NumberPicker',
      },
    },
  ],
})
